<template>
  <div
    class="auth-wrapper auth-v1"
    style="background-color: #eff1f3"
  >
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card class="mb-0">
        <b-link
          class="brand-logo"
          @click="$router.push('/')"
        >
          <logo-vsl-booster />

        </b-link>
        <validation-observer ref="registerForm">
          <b-form
            class="auth-register-form"
            @submit.prevent="validationForm"
          >
            <div class="text-center divider-custom">
              <span
                class="text-center"
                style="font-size: 1.2rem"
              >
                Dados Pessoais
              </span>
            </div>

            <!-- email -->
            <b-form-group
              label="Email"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="formPaymen.email"
                  :state="errors.length > 0 ? false:null"
                  name="email"
                  :disabled="disabledInput('email')"
                  placeholder="Seu e-mail"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Nome Completo"
              label-for="username"
            >
              <validation-provider
                #default="{ errors }"
                name="nome_completo"
                rules="required"
              >
                <b-form-input
                  id="nome_completo"
                  v-model="formPaymen.nome_completo"
                  :state="errors.length > 0 ? false:null"
                  name="nome_completo"
                  :disabled="disabledInput('nome_completo')"
                  autocomplete="name"
                  placeholder="johndoe"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-row>
              <b-col
                cols="12"
                md="6"
                class="pr-0"
              >

                <b-form-group
                  label="CPF"
                  label-for="cpf"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Bairro"
                    rules="required"
                  >
                    <b-form-input
                      id="cpf"
                      v-model="formPaymen.document"
                      v-mask="dynamicMaskDocument"
                      :state="errors.length > 0 ? false:null"
                      name="cpf"
                      :disabled="disabledInput('document')"
                      placeholder="CPF"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <!--  Celular -->
                <b-form-group
                  label="Celular com DDD"
                  label-for="celular_ddd"
                >
                  <b-input-group class="input-group-merge">
                    <cleave
                      id="celular_ddd"
                      v-model="formPaymen.celular_ddd"
                      class="form-control"
                      :disabled="disabledInput('celular_ddd')"
                      :class="{ 'is-invalid': isValidadePhone.error }"
                      name="celular_ddd"
                      :raw="false"
                      :options="{
                        delimiters: [' ', '-'],
                        blocks: [2, 5, 4],
                        uppercase: true,
                      }"
                      placeholder="99 99999-9999"
                    />
                  </b-input-group>
                  <small
                    v-if="isValidadePhone.error"
                    class="text-danger"
                  >{{ isValidadePhone.message }}</small>
                </b-form-group>
              </b-col>
            </b-row>

            <b-tabs
              justified
              pills
            >
              <b-tab
                title="Home"
                active
                @click="changeMethodPayment('credit_card')"
              >
                <template #title>
                  <svg
                    width="20"
                    height="20"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="far"
                    data-icon="credit-card"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    class="svg-inline--fa fa-credit-card fa-w-18 mr-2 w-4 h-4 sm:w-6 sm:h-6"
                  ><path
                    fill="currentColor"
                    d="M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
                  /></svg>
                  <span class="align-middle">Cartão</span>
                </template>
                <b-card
                  border-variant="primary"
                  bg-variant="transparent"
                  class="shadow-none"
                >
                  <b-row>
                    <b-col
                      cols="12"
                      class="text-center divider-custom mb-1"
                    >
                      <span>
                        Dados do cartão
                      </span>
                    </b-col>
                    <b-col
                      cols="12"
                      class="p-0"
                    >
                      <b-form-group
                        label="CPF ou CNPJ do portador do cartão."
                        label-for="holder_document"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Bairro"
                          rules="required"
                        >
                          <b-form-input
                            id="holder_document"
                            v-model="formPaymen.credit_card.holder_document"
                            v-mask="dynamicMaskHolderDocument"
                            autocomplete="number"
                            :state="errors.length > 0 ? false:null"
                            name="address-line-1"
                            placeholder="000.000.000-00 ou 00.000.000/0000-00"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <!-- Nome do Cartão -->
                    <b-col
                      cols="12"
                      class="p-0"
                    >

                      <b-form-group
                        label="Nome do Titular do Cartão"
                        label-for="holder_name_card"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Nome do Titular do Cartão"
                          rules="required"
                        >
                          <b-form-input
                            id="holder_name_card"
                            v-model="formPaymen.credit_card.holder_name"
                            name="holder_name_card"
                            autocomplete="off"
                            :state="errors.length > 0 ? false:null"
                            placeholder="Ex.: João da Silva"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <!-- username -->
                    <b-col
                      cols="12"
                      class="p-0"
                    >
                      <b-form-group
                        label="Numero do Cartão"
                        label-for="number_card"
                      >
                        <b-input-group class="input-group-merge">
                          <cleave
                            id="number_card"
                            v-model="formPaymen.credit_card.number"
                            class="form-control"
                            name="number_card"
                            :class="{ 'is-invalid': isValidadeNumberCard.error }"
                            :raw="false"
                            :options="{
                              creditCard: true,
                              uppercase: true
                            }"
                            placeholder="Ex.: 0000 0000 0000 0000"
                          />
                        </b-input-group>
                        <small
                          v-if="isValidadeNumberCard.error"
                          class="text-danger"
                        >{{ isValidadeNumberCard.message }}</small>
                      </b-form-group>
                    </b-col>

                    <!-- email -->
                    <b-col
                      cols="12"
                      md="3"
                      class="pl-0"
                    >
                      <b-form-group
                        label="Mês"
                        label-for="fh-email"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Mês"
                          rules="required"
                        >
                          <b-input-group class="input-group-merge">
                            <b-form-select
                              v-model="formPaymen.credit_card.exp_month"
                              :class="{ 'is-invalid': isValidadeRequiredMonth.error }"
                              :state="errors.length > 0 ? false:null"
                              :options="[
                                {
                                  text: 'Mês',
                                  value: null,
                                  disabled: true,
                                },
                                {
                                  text: 'Janeiro',
                                  value: 1
                                },
                                {
                                  text: 'Fevereiro',
                                  value: 2
                                },
                                {
                                  text: 'Março',
                                  value: 3
                                },
                                {
                                  text: 'Abril',
                                  value: 4
                                },
                                {
                                  text: 'Maio',
                                  value: 5
                                },
                                {
                                  text: 'Junho',
                                  value: 6
                                },
                                {
                                  text: 'Julho',
                                  value: 7
                                },
                                {
                                  text: 'Agosto',
                                  value: 8
                                },
                                {
                                  text: 'Setembro',
                                  value: 9
                                },
                                {
                                  text: 'Outubro',
                                  value: 10
                                },
                                {
                                  text: 'Novembro',
                                  value: 11
                                },
                                {
                                  text: 'Dezembro',
                                  value: 12
                                }
                              ]"
                            />
                          </b-input-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <!-- email -->
                    <b-col
                      cols="12"
                      md="3"
                      class="pl-0"
                    >
                      <b-form-group
                        label="Ano"
                        label-for="fh-email"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Ano"
                          rules="required"
                        >

                          <b-input-group class="input-group-merge">
                            <!--                          ano vencimento cartão -->
                            <b-form-select
                              v-model="formPaymen.credit_card.exp_year"
                              :class="{ 'is-invalid': isValidadeRequiredYear.error }"
                              :state="errors.length > 0 ? false:null"
                              :options="[
                                {
                                  text: 'Ano',
                                  value: null,
                                  disabled: true,
                                },
                                {
                                  text: '2023',
                                  value: 23
                                },
                                {
                                  text: '2024',
                                  value: 24
                                },
                                {
                                  text: '2025',
                                  value: 25
                                },
                                {
                                  text: '2026',
                                  value: 26
                                },
                                {
                                  text: '2027',
                                  value: 27
                                },
                                {
                                  text: '2028',
                                  value: 28
                                },
                                {
                                  text: '2029',
                                  value: 29
                                },
                                {
                                  text: '2030',
                                  value: 30
                                },
                                {
                                  text: '2031',
                                  value: 31
                                },
                                {
                                  text: '2032',
                                  value: 32
                                },
                                {
                                  text: '2033',
                                  value: 33
                                },
                                {
                                  text: '2034',
                                  value: 34
                                },
                                {
                                  text: '2035',
                                  value: 35
                                },
                                {
                                  text: '2036',
                                  value: 36
                                },
                                {
                                  text: '2037',
                                  value: 37
                                },
                                {
                                  text: '2038',
                                  value: 38
                                },
                                {
                                  text: '2039',
                                  value: 39
                                },
                                {
                                  text: '2040',
                                  value: 40
                                }
                              ]"
                            />
                          </b-input-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        <small
                          v-if="isValidadeRequiredYear.error"
                          class="text-danger"
                        >{{ isValidadeRequiredYear.message }}</small>
                      </b-form-group>
                    </b-col>
                    <!-- email -->
                    <b-col
                      cols="12"
                      md="6"
                      class="p-0"
                    >
                      <b-form-group
                        label="Código de Segurança"
                        label-for="card_cvv"
                      >
                        <b-input-group class="input-group-merge">
                          <cleave
                            id="card_cvv"
                            v-model="formPaymen.credit_card.cvv"
                            class="form-control"
                            :class="{ 'is-invalid': isValidadeRequiredCvv.error }"
                            :raw="false"
                            :options="{blocks: [4]}"
                            placeholder="Código de Segurança"
                          />
                          <b-input-group-append is-text>
                            <feather-icon
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              v-b-tooltip.hover.top="'O CVV/Cód. segurança é o código de 3 dígitos que aparece atrás do seu cartão'"
                              icon="HelpCircleIcon"
                              style="cursor: help"
                            />
                          </b-input-group-append>
                        </b-input-group>
                        <small
                          v-if="isValidadeRequiredCvv.error"
                          class="text-danger"
                        >{{ isValidadeRequiredCvv.message }}</small>
                      </b-form-group>
                    </b-col>

                    <b-col
                      cols="12"
                      class="text-center divider-custom"
                    >
                      <span>
                        Plano a ser contratado
                      </span>
                    </b-col>
                    <b-col
                      cols="12"
                      class="p-0"
                    >
                      <b-form-group
                        label="Assinatura"
                        label-for="fh-email"
                      >
                        <b-input-group class="input-group-merge">
                          <!--                          ano vencimento cartão -->
                          <b-form-select
                            v-model="formPaymen.valor_compra"
                            :options="[
                              {
                                text: 'R$ 72,00 / mês',
                                value: '7200'
                              },
                            ]"
                          />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="12"
                      class="text-center divider-custom"
                    >
                      <span>
                        Endereço da fatura do cartão
                      </span>
                    </b-col>
                    <b-col
                      cols="12"
                      class="p-0 mt-0"
                    >
                      <address-billing v-model="formPaymen.billing_address" />
                    </b-col>
                  </b-row>
                </b-card>
              </b-tab>
              <b-tab @click="changeMethodPayment('boleto')">
                <template #title>
                  <svg
                    id="svg3013"
                    width="20"
                    height="20"
                    viewBox="0 -256 1850 1850"
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    class="mr-2 w-4 h-4 sm:w-6 sm:h-6"
                  ><g
                    id="g3015"
                    transform="matrix(1,0,0,-1,37.966102,1313.0508)"
                  ><path
                    id="path3017"
                    d="M 672,1408 V -128 h -64 v 1536 h 64 z m 736,0 V -128 h -64 v 1536 h 64 z m 160,0 V -128 h -64 v 1536 h 64 z m -992,0 V -128 h -64 v 1536 h 64 z m 704,0 V -128 h -256 v 1536 h 256 z m -384,0 V -128 H 768 v 1536 h 128 z m -448,0 V -128 H 320 v 1536 h 128 z m 1344,0 V -128 h -128 v 1536 h 128 z m -1536,0 V -128 H 0 v 1536 h 256 z"
                    inkscape:connector-curvature="0"
                    style="fill: currentcolor;"
                  /></g></svg>
                  <span class="align-middle">Boleto</span>
                </template>
                <b-card
                  border-variant="primary"
                  bg-variant="transparent"
                  class="shadow-none"
                  no-body
                >
                  <b-card-text class="p-1">
                    <b-alert
                      variant="primary"
                      show
                    >
                      <div class="alert-body">
                        <span>
                          <strong>Informações sobre o pagamento via boleto:</strong>
                          <br>
                          <ul>
                            <li>Valor boleto: R$ 72,00 / mês.</li>
                            <li>Não podemos parcelar Boleto.</li>
                            <li>Pode levar até 2 dias úteis para compensar.</li>
                          </ul>
                        </span>
                      </div>
                    </b-alert>
                  </b-card-text>
                </b-card>
              </b-tab>
              <b-tab @click="changeMethodPayment('pix')">
                <template #title>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 166 166"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mr-2 w-4 h-4 sm:w-6 sm:h-6"
                  ><path
                    d="M128.886 126.429C122.402 126.429 116.304 123.904 111.719 119.321L86.9305 94.5328C85.1908 92.7877 82.1569 92.7931 80.4173 94.5328L55.5383 119.412C50.9529 123.994 44.8548 126.519 38.3704 126.519H33.4857L64.8802 157.914C74.6853 167.718 90.5823 167.718 100.387 157.914L131.873 126.429H128.886Z"
                    fill="currentColor"
                  /> <path
                    d="M38.3705 38.7476C44.8549 38.7476 50.953 41.2731 55.5376 45.8562L80.4166 70.739C82.2083 72.5308 85.1342 72.5385 86.9306 70.7367L111.719 45.9464C116.304 41.3633 122.402 38.8385 128.887 38.8385H131.872L100.388 7.35388C90.5824 -2.45126 74.6854 -2.45126 64.8803 7.35388L33.4866 38.7476H38.3705Z"
                    fill="currentColor"
                  /> <path
                    d="M157.914 64.8806L138.888 45.8541C138.469 46.022 138.015 46.1269 137.537 46.1269H128.887C124.414 46.1269 120.036 47.9404 116.876 51.1026L92.0874 75.8914C89.7686 78.2109 86.7207 79.3722 83.6752 79.3722C80.6273 79.3722 77.5818 78.2109 75.2622 75.8937L50.3809 51.0124C47.2204 47.8503 42.8433 46.0368 38.3705 46.0368H27.7337C27.2805 46.0368 26.8561 45.9295 26.4558 45.7787L7.35385 64.8806C-2.45128 74.685 -2.45128 90.582 7.35385 100.388L26.455 119.489C26.8553 119.338 27.2805 119.231 27.7337 119.231H38.3705C42.8433 119.231 47.2204 117.417 50.3809 114.255L75.2599 89.3763C79.7567 84.8834 87.5952 84.8811 92.0874 89.3787L116.876 114.164C120.036 117.327 124.414 119.141 128.887 119.141H137.537C138.016 119.141 138.469 119.245 138.888 119.413L157.914 100.388C167.719 90.582 167.719 74.685 157.914 64.8806Z"
                    fill="currentColor"
                  /></svg>
                  <span class="align-middle">Pix</span>
                </template>
                <b-card
                  border-variant="primary"
                  bg-variant="transparent"
                  class="shadow-none"
                  no-body
                >
                  <b-card-text class="p-1">
                    <b-alert
                      variant="primary"
                      show
                    >
                      <div class="alert-body">
                        <span>
                          <strong>Informações sobre o pagamento via pix:</strong>
                          <br>
                          <ul>
                            <li>Valor à vista: R$ 72,00 / mês.</li>
                            <li>Liberação imediata!</li>
                            <li>É simples, só usar o aplicativo de seu banco para pagar PIX.</li>
                            <li>Super seguro. O pagamento PIX foi desenvolvido pelo Banco Central para facilitar pagamentos.</li>
                          </ul>
                        </span>
                      </div>
                    </b-alert>
                  </b-card-text>
                </b-card>
              </b-tab>
            </b-tabs>

            <!-- submit button -->
            <b-button
              variant="success"
              class="text-uppercase"
              block
              type="submit"
              :disabled="loading"
            >
              Pagar Agora
            </b-button>
          </b-form>
        </validation-observer>
        <b-overlay
          :show="loading"
          no-wrap
        >
          <b-skeleton
            class="w-100"
            height="100%"
            type="form"
            variant="light"
          />
        </b-overlay>
      </b-card>
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BCardText, BForm, BTab, BTabs,
  BButton, BFormInput, BFormGroup, BIcon, VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import LogoVslBooster from '@/components/LogoVslBooster.vue'
import Cleave from 'vue-cleave-component'
import AddressBilling from '@/views/App/PaymentView/AddresBilling.vue'
import Swal from 'sweetalert2'

export default {
  components: {
    AddressBilling,
    LogoVslBooster,
    // BSV
    BCard,
    BLink,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    // validations
    ValidationProvider,
    ValidationObserver,
    BTab,
    BTabs,
    Cleave,
    BIcon,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      inputDisabled: [],
      formPaymen: {
        nome_completo: '',
        email: '',
        confirme_email: '',
        document: '',
        valor_compra: '7200',
        celular_ddd: null,
        method_payment: 'credit_card',
        credit_card: {
          holder_document: '',
          holder_name: '',
          number: null,
          exp_month: null,
          exp_year: null,
          cvv: null,
        },
        billing_address: {
          zip_code: '',
          rua: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          estado: '',
          country: 'BR',
        },
        installments: 1,
      },
      isValidadeCPF: {
        error: false,
        message: 'CPF é obrigatório',
      },
      isValidadePhone: {
        error: false,
        message: 'Celular é obrigatório',
      },
      // validation rules
      required,
      email,
      isValidadeNumberCard: {
        error: false,
        message: 'Campo obrigatório',
      },
      isValidadeHolderDocument: {
        error: false,
        message: 'Campo obrigatório',
      },
      isValidadeRequiredMonth: {
        error: false,
        message: 'Campo obrigatório',
      },
      isValidadeRequiredYear: {
        error: false,
        message: 'Campo obrigatório',
      },
      isValidadeRequiredCvv: {
        error: false,
        message: 'Campo obrigatório',
      },
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    userData() {
      return this.$store.getters['User/getUser']
    },
    dynamicMaskDocument() {
      return this.formPaymen.document.length <= 14 ? '###.###.###-##' : '##.###.###/####-##'
    },
    dynamicMaskHolderDocument() {
      return this.formPaymen.credit_card.holder_document.length <= 14 ? '###.###.###-##' : '##.###.###/####-##'
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loading = true
      if (typeof this.$route.query.uuid !== 'undefined') {
        this.$store.dispatch('User/findUserByUUID', { uuid: this.$route.query.uuid })
          .then(resp => {
            this.formPaymen.nome_completo = `${this.strReplaceTrim(resp.user_name)} ${this.strReplaceTrim(resp.user_sobrenome)}`
            this.formPaymen.email = this.strReplaceTrim(resp.user_email)
            this.formPaymen.celular_ddd = resp.user_phone.replace('+55', '').replace(/\D/g, '')
            this.inputDisabled = ['nome_completo', 'email']
          })
          .finally(() => {
            this.loading = false
          })
      }
    })
  },
  methods: {
    generateUniqueCode(tamanho = 16) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let code = ''

      for (let i = 0; i < tamanho; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length)
        code += characters.charAt(randomIndex)
      }

      return code
    },
    strReplaceTrim(str) {
      if (str === null) return ''
      return str.replace(/\s/g, '')
    },
    disabledInput(name) {
      return this.inputDisabled.includes(name)
    },
    changeMethodPayment(e) {
      this.formPaymen.method_payment = e
    },
    validarCPF(cpf) {
      const cpfLimpo = cpf.replace(/\D/g, '')

      if (cpfLimpo.length !== 11) {
        return false
      }

      if (/^(\d)\1+$/.test(cpfLimpo)) {
        return false
      }

      let soma = 0
      for (let i = 0; i < 9; i++) {
        soma += parseInt(cpfLimpo.charAt(i)) * (10 - i)
      }
      let primeiroDigitoVerificador = 11 - (soma % 11)
      if (primeiroDigitoVerificador > 9) {
        primeiroDigitoVerificador = 0
      }

      if (parseInt(cpfLimpo.charAt(9)) !== primeiroDigitoVerificador) {
        return false
      }

      soma = 0
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpfLimpo.charAt(i)) * (11 - i)
      }
      let segundoDigitoVerificador = 11 - (soma % 11)
      if (segundoDigitoVerificador > 9) {
        segundoDigitoVerificador = 0
      }

      if (parseInt(cpfLimpo.charAt(10)) !== segundoDigitoVerificador) {
        return false
      }

      return true
    },
    isPessoaFisica(documento) {
      const digitsOnly = documento.replace(/\D/g, '') // Remove caracteres não numéricos
      if (digitsOnly.length === 11) {
        return 'CPF'
      } if (digitsOnly.length === 14) {
        return 'CNPJ'
      }
      return 'Documento inválido'
    },
    validarNumeroComDDD(numero) {
      const numeroLimpo = numero.replace(/\D/g, '')
      if (numeroLimpo.length !== 10 && numeroLimpo.length !== 11) {
        return false
      }

      const ddd = numeroLimpo.substr(0, 2)
      const dddNumero = parseInt(ddd, 10)
      if (dddNumero < 11 || dddNumero > 99) {
        return false
      }
      this.formPaymen.celular_ddd = numeroLimpo
      return true
    },
    validationForm() {
      if (this.validarCPF(this.formPaymen.document) === false) {
        this.isValidadeCPF.error = true
        this.isValidadeCPF.message = this.formPaymen.document === '' ? 'CPF é obrigatório' : 'CPF inválido'
        this.$refs.registerForm.validate()
      } else {
        this.isValidadeCPF.error = false
      }

      if (!this.validarNumeroComDDD(this.formPaymen.celular_ddd)) {
        this.isValidadePhone.error = true
        this.isValidadePhone.message = this.formPaymen.celular_ddd === '' ? 'Celular é obrigatório' : 'Celular inválido'
        this.$refs.registerForm.validate()
      } else {
        this.isValidadePhone.error = false
      }

      if (this.formPaymen.method_payment === 'credit_card') {
        this.$refs.registerForm.validate()

        if (this.formPaymen.credit_card.number === '') {
          this.isValidadeNumberCard.error = true
        } else {
          this.isValidadeNumberCard.error = false
        }

        if (this.formPaymen.credit_card.exp_month === '') {
          this.isValidadeRequiredMonth.error = true
        } else {
          this.isValidadeRequiredMonth.error = false
        }

        if (this.formPaymen.credit_card.holder_document === '') {
          this.isValidadeHolderDocument.error = true
        } else {
          this.isValidadeHolderDocument.error = false
        }

        if (this.formPaymen.credit_card.exp_year === '') {
          this.isValidadeRequiredYear.error = true
        } else {
          this.isValidadeRequiredYear.error = false
        }

        if (this.formPaymen.credit_card.cvv === '') {
          this.isValidadeRequiredCvv.error = true
        } else {
          this.isValidadeRequiredCvv.error = false
        }
      }

      if (this.isValidadeCPF.error || this.isValidadePhone.error || this.isValidadeNumberCard.error || this.isValidadeRequiredMonth.error || this.isValidadeRequiredYear.error || this.isValidadeRequiredCvv.error) {
        return
      }

      this.$refs.registerForm.validate().then(success => {
        let validadePixBoleto = false
        if (this.formPaymen.method_payment === 'boleto' || this.formPaymen.method_payment === 'pix') {
          const { nome_completo, Email } = this.$refs.registerForm.errors
          validadePixBoleto = nome_completo.length === 0 && Email.length === 0
        }
        console.log(this.$refs.registerForm.errors, this.formPaymen.method_payment)
        const codeAssinatura = this.generateUniqueCode()
        let pathSave = 'pedidos'
        // plano teste: plan_d7ovapOhlnULBROn
        // plano prod: plan_Rq41eM2T3ec3E1WN - VSL Booster Starter
        // plano prod: plan_z9J0AyiZkHoA0Alw - VSL Booster PRO
        const planoAtual = 'plan_Rq41eM2T3ec3E1WN'
        this.$store.commit('appPayment/SET_ID_PEDIDO_PAGARME', codeAssinatura)
        if (success || validadePixBoleto) {
          this.loading = true
          let dataTrasform = {
            code: codeAssinatura,
            customer: {
              code: this.userData.id,
              name: this.formPaymen.nome_completo,
              email: this.formPaymen.email,
              document: this.formPaymen.document.replace(/\D/g, ''),
              document_type: this.isPessoaFisica(this.formPaymen.document),
              type: this.isPessoaFisica(this.formPaymen.document) === 'CPF' ? 'individual' : 'company',
              phones: {
                home_phone: {
                  country_code: '55',
                  area_code: this.formPaymen.celular_ddd.replace(/\D/g, '').substr(0, 2),
                  number: this.formPaymen.celular_ddd.replace(/\D/g, '').substr(2, 9),
                },
              },
              metadata: {
                uuid: this.userData.uuid,
              },
            },
          }

          if (this.formPaymen.method_payment === 'credit_card') {
            pathSave = 'assinaturas'
            dataTrasform = {
              ...dataTrasform,
              card: {
                holder_document: this.formPaymen.credit_card.holder_document.replace(/\D/g, ''),
                holder_name: this.formPaymen.credit_card.holder_name,
                number: this.formPaymen.credit_card.number.replace(/\D/g, ''),
                exp_month: this.formPaymen.credit_card.exp_month,
                exp_year: this.formPaymen.credit_card.exp_year,
                cvv: this.formPaymen.credit_card.cvv,
                billing_address: {
                  line_1: `${this.formPaymen.billing_address.numero}, ${this.formPaymen.billing_address.rua}, ${this.formPaymen.billing_address.bairro}`,
                  line_2: this.formPaymen.billing_address.complemento,
                  zip_code: this.formPaymen.billing_address.zip_code.replace(/\D/g, ''),
                  city: this.formPaymen.billing_address.cidade,
                  state: this.formPaymen.billing_address.estado,
                  country: 'BR',
                },
              },
              plan_id: planoAtual,
              payment_method: 'credit_card',
              boleto_due_days: 5,
            }
          }

          if (this.formPaymen.method_payment === 'boleto') {
            pathSave = 'assinaturas'
            dataTrasform = {
              ...dataTrasform,
              plan_id: planoAtual,
              payment_method: 'boleto',
              boleto_due_days: 5,
            }
          }

          if (this.formPaymen.method_payment === 'pix') {
            dataTrasform = {
              ...dataTrasform,
              items: [
                {
                  code: this.generateUniqueCode(),
                  description: 'STARTER BOOSTER',
                  amount: this.formPaymen.valor_compra,
                  quantity: 1,
                },
              ],
              payments: [
                {
                  payment_method: 'pix',
                  pix: {
                    expires_in: '52134613',
                    additional_information: [
                      {
                        name: 'Pagamento',
                        value: 'STARTER BOOSTER',
                      },
                    ],
                  },
                },
              ],
              closed: false,
            }
          }
          this.$store.dispatch('appPayment/submitForm', { data: dataTrasform, patchApi: pathSave, methodPayment: this.formPaymen.method_payment })
            .then(res => {
              this.$refs.registerForm.reset()
              if (res.data.data.status === 'pending' && this.formPaymen.method_payment === 'boleto') {
                this.$store.dispatch('storeNotifications/sendNotifications', {
                  titulo: 'Boleto Gerado com Sucesso',
                  descricao: `Olá ${this.userData.user_name} ${this.userData.user_sobrenome}, informamos que o boleto referente ao pagamento está disponível. Enviamos o boleto para o seu e-mail ${this.userData.user_email}.`,
                  id_user: this.userData.id,
                  type: 'success',
                  link: '#',
                  target: false,
                  evento: 'boleto.generate',
                })
                this.$router.push({ name: 'payment-boleto' })
                return
              }

              if (res.data.data.status === 'pending' && this.formPaymen.method_payment === 'pix') {
                this.$store.dispatch('storeNotifications/sendNotifications', {
                  titulo: 'PIX Gerado com Sucesso',
                  descricao: `Olá ${this.userData.user_name} ${this.userData.user_sobrenome}, informamos que o PIX referente ao pagamento foi gerado e enviado para o seu e-mail ${this.userData.user_email}.`,
                  id_user: this.userData.id,
                  type: 'success',
                  link: '#',
                  target: false,
                  evento: 'pix.generate',
                })
                this.$router.push({ name: 'payment-pix' })
                return
              }
              if (res.data.data.status === 'paid') {
                this.$store.dispatch('storeNotifications/sendNotifications', {
                  titulo: 'Pagamento Realizado com Sucesso',
                  descricao: `Olá ${this.userData.user_name} ${this.userData.user_sobrenome}, agradecemos por efetuar o pagamento com sucesso! Seu pagamento foi processado e aprovado. Agora você pode continuar desfrutando de todos os benefícios de nossos serviços.`,
                  id_user: this.userData.id,
                  type: 'success',
                  link: '#',
                  target: false,
                  evento: 'pagamento.paid',
                })
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pagamento',
                    text: 'Pagamento realizado com sucesso',
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                this.$router.push('/dashboard')
                return
              }
              if (res.data.data.status === 'failed') {
                this.$store.dispatch('storeNotifications/sendNotifications', {
                  titulo: 'Falha de Pagamento',
                  descricao: `Prezado(a) ${this.userData.user_name} ${this.userData.user_sobrenome}, informamos que houve uma falha no processamento do seu pagamento. Pedimos que verifique seus dados e tente novamente.`,
                  id_user: this.userData.id,
                  type: 'danger',
                  link: `/payment?uuid=${this.userData.uuid}`,
                  target: true,
                  evento: 'pagamento.failed',
                })
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pagamento',
                    text: 'Pagamento não realizado',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(() => {
              Swal.fire({
                icon: 'error',
                title: 'Error na transação',
                text: 'Por favor, verifique os dados do cartão e tente novamente.',
              })
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';
.auth-wrapper.auth-v1 .auth-inner {
  max-width: 600px !important;
}
.title-custom-form {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.divider-custom {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 0.5em;
}

.divider-custom:before {
  content: "";
  flex: 1;
  align-self: center;
  border-bottom: 1px solid red;
  position: relative;
  top: 5%;
  margin-right: 5px;
}

.divider-custom:after {
  content: "";
  flex: 1;
  align-self: center;
  border-bottom: 1px solid red;
  position: relative;
  top: 5%;
  margin-left: 5px;
}

</style>
